import { FailedToGetData, H2, Hr, Loading, RadioSelector } from 'src/components/_commons';
import { houseToHouseServices, userServices } from 'src/services';
import { setAlertResponse } from 'src/store';
import { sse } from '@/app-config';
import { sseEvents } from '@monorepo/helpers';
import { typeHTHTerritory, typeUser } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { useGetCurrentUser } from 'src/custom-hooks';
import * as Subcomponents from './subcomponents';

export const AdminsHTH = () => {
    const [hthTerritories, setHthTerritories] = useState<typeHTHTerritory[] | null>(null);
    const [isLoading1, setIsLoading1] = useState(true);
    const [isLoading2, setIsLoading2] = useState(true);
    const [radioValue, setRadioValue] = useState<'0' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8'>('0');
    const [refreshCounter, setRefreshCounter] = useState(0);
    const [users, setUsers] = useState<typeUser[] | null>(null);
    const [usersRefreshCounter, setUsersRefreshCounter] = useState(0);
    const dispatch = useDispatch();
    const user = useGetCurrentUser()

    useEffect(() => {
        houseToHouseServices.GetTerritoriesForStatistics().then(response => {
            setIsLoading1(false);
            if (!response.success || !response.data?.hthTerritories) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setHthTerritories(response.data.hthTerritories);
        });
    }, [refreshCounter]);

    useEffect(() => {
        userServices.GetAll().then(response => {
            setIsLoading2(false);
            if (!response.success || !response.data?.users) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setUsers(response.data.users);
        });
    }, [usersRefreshCounter]);

    useEffect(() => {
        const handler = (e: MessageEvent) => {
            const data = JSON.parse(e.data);
            if (data.congregation !== user.congregation) {
                return;
            }
            setRefreshCounter(x => x + 1);
        }
        sse.addEventListener(sseEvents.hthChange, handler);
        return () => {
            sse.removeEventListener(sseEvents.hthChange, handler);
        };
    }, [user.congregation]);

    useEffect(() => {
        const handler = (e: MessageEvent) => {
            const data = JSON.parse(e.data);
            if (data.congregation !== user.congregation) {
                return;
            }
            setUsersRefreshCounter(x => x + 1);
        }
        sse.addEventListener(sseEvents.userChange, handler);
        return () => {
            sse.removeEventListener(sseEvents.userChange, handler);
        };
    }, [user.congregation]);

    if (isLoading1 || isLoading2) {
        return <Loading mt={'80px'} />;
    }

    if (!hthTerritories || !users) {
        return <FailedToGetData />;
    }

    return (
        <div className={'container'}>
            <H2 title={'ADMINISTRACIÓN CASA EN CASA'} />
            <RadioSelector
                additionalKey={'AP1'}
                options={[
                    { label: (radioValue === '1' ? 'Viendo' : 'Ver') + ' Actividad', type: '1'},
                    // { label: (radioValue === '2' ? 'Viendo' : 'Ver') + ' Mapa de Territorios', type: '2'},
                    { label: (radioValue === '3' ? 'Viendo' : 'Ver') + ' Predicación de Ed.', type: '3'},
                    { label: (radioValue === '4' ? 'Viendo' : 'Ver') + ' Asignaciones', type: '4'}
                ]}
                radioValue={radioValue}
                removeMargin
                setRadioValue={setRadioValue}
            />
            <RadioSelector
                additionalKey={'AP2'}
                options={[
                    { label: radioValue === '5' ? 'Viendo Edificios' : 'Ver Edificios', type: '5'},
                    { label: radioValue === '6' ? 'Viendo Reestructuración' : 'Ver Reestructuración', type: '6'},
                    { label: radioValue === '7' ? 'Viendo Configuración' : 'Ver Configuración', type: '7'}
                ]}
                radioValue={radioValue}
                removeMargin
                setRadioValue={setRadioValue}
            />
            <Hr classes={'mt-5 mx-auto'} />
            <div>
                {radioValue === '1' &&
                    <Subcomponents.HTHActivity
                        hthTerritories={hthTerritories}
                        setHthTerritories={setHthTerritories}
                    />
                }
                {radioValue === '2' &&  // not being used
                    <Subcomponents.HTHInteractiveMap
                        hthTerritories={hthTerritories}
                    />
                }
                {radioValue === '3' &&
                    <Subcomponents.HTHBuildingsActivity
                    hthTerritories={hthTerritories}
                    />
                }
                {radioValue === '4' &&
                    <Subcomponents.HTHAssignments
                        hthTerritories={hthTerritories}
                        users={users}
                    />
                }
                {radioValue === '5' &&
                    <Subcomponents.HTHBuildingsForAdmins
                        hthTerritories={hthTerritories}
                    />
                }
                {radioValue === '6' &&
                    <Subcomponents.HTHRestructuring
                        close={() => setRadioValue('0')}
                        hthTerritories={hthTerritories}
                    />
                }
                {radioValue === '7' &&
                    <Subcomponents.HTHConfig />
                }
            </div>
        </div>
    );
}
